module.exports = __webpack_public_path__ + "img/login0.e51427e2.png";